import Modal from '@monofront/design-system/organisms/Modal';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { useContext, useEffect, useState } from 'react';
import { RichText } from 'prismic-reactjs';
import { LayoutContext } from '@context/LayoutContext';
import { useRouter } from 'next/router';
import { isMobileApp } from '@utils/environment';
import { useAuthentication } from '@context/businessContainer';
import { useLocalStorage } from '@monofront/business/hooks';
import { INFORMATION_MODAL_RECORDED_TIME } from '@constants/localStorage';
import dayjs from 'dayjs';
import { trackEvent } from '@monofront/tracking';

const InformationsModal = () => {
  const { informationsModal } = useContext(LayoutContext);
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();

  const { customer } = useAuthentication();
  const [lastRecordedTime, setLastRecordedTime] = useLocalStorage(
    INFORMATION_MODAL_RECORDED_TIME,
    '',
  );

  useEffect(() => {
    if (
      lastRecordedTime === '' ||
      dayjs(lastRecordedTime).isBefore(dayjs().subtract(1, 'day'))
    ) {
      setIsOpen(true);
      setLastRecordedTime(dayjs().toString());
      trackEvent({ type: 'LFWarningPopin' });
    }
  }, []);

  if (
    !informationsModal ||
    !isOpen ||
    isMobileApp ||
    router.asPath.includes('/cart') ||
    router.asPath.includes('/checkout') ||
    !customer?.orderCount
  ) {
    return null;
  }

  return (
    // TODO: modal is not done yet in design system. Plug it here when created in design system (AKOUBAYOOOYO magic system!)
    <Modal
      isOpen={isOpen}
      externalToggle={() => setIsOpen(false)}
      UNSAFE_className="tw-max-w-[399px] tw-mt-[10%]"
      hasPadding
      isClosable={false}
    >
      <div className="tw-flex tw-flex-col tw-justify-center tw-px-7 tw-pb-7 tw-pt-2">
        <ResponsiveImage
          src={informationsModal.image.url}
          alt={informationsModal.image.alt}
          width={80}
          height={80}
        />
        <h3 className="tw-lf-body-bold-md tw-mb-2 tw-mt-6 tw-text-center">
          {informationsModal.title}
        </h3>
        <div className="tw-text-center">
          <RichText render={informationsModal.text} />
        </div>
        <button
          className="tw-lf-button tw-lf-button-primary tw-lf-button-md tw-mt-6"
          onClick={() => {
            setIsOpen(false);
            setLastRecordedTime(dayjs().toString());
          }}
        >
          {informationsModal.button_label}
        </button>
      </div>
    </Modal>
  );
};

export default InformationsModal;
